import React, { useEffect } from 'react';
import { bool, number, func } from 'prop-types';
import Scrollbar from 'react-scrollbars-custom';

const applyIEWorkaround = () => {
	setTimeout(() => {
		const wrapperEl = document.querySelector('.trackYVisible');
		const contentEl = document.querySelector('.ScrollbarsCustom-Content');
		const scrollbarEl = document.querySelector('.ScrollbarsCustom-TrackY');

		// Is contentEl scrollheight passed clientHeight
		if (scrollbarEl) {
			if (wrapperEl && contentEl && contentEl.scrollHeight <= wrapperEl.clientHeight) {
				if (!scrollbarEl.classList.contains('hide')) {
					scrollbarEl.classList.add('hide');
				}
			} else {
				scrollbarEl.classList.remove('hide');
			}
		}
	}, 100);
};

const scrollStop = (values, onScrollStop, hasReachedBottom) => {
	if (onScrollStop) {
		onScrollStop(values.scrollTop);
	}
	if (hasReachedBottom) {
		const scrollTotal = values.scrollTop + values.clientHeight;

		if (scrollTotal >= values.scrollHeight - 15) {
			hasReachedBottom(true);
		} else {
			hasReachedBottom(false);
		}
	}
};

const BloxScrollViewNew = ({
	purple,
	scrollTop,
	onScrollStop,
	children,
	height,
	module,
	onHoverOver,
	onHoverOut,
	hasReachedBottom,
}) => {
	let scrollBarClass = purple ? ' purple' : '';
	if (module) {
		scrollBarClass = module ? ` ${module.toLowerCase()}` : '';
	}

	useEffect(applyIEWorkaround);

	const ua = window.navigator.userAgent;
	const isIE = /MSIE|Trident/.test(ua);
	const isEdge = /Edge\/\d./i.test(navigator.userAgent);

	if (isIE || isEdge) {
		return (
			<Scrollbar
				thumbYProps={{
					renderer: props => {
						const { elementRef, ...restProps } = props;
						return (
							<div
								{...restProps}
								ref={elementRef}
								className={`ScrollbarsCustom-Thumb ScrollbarsCustom-ThumbY${scrollBarClass}`}
							/>
						);
					},
				}}
				trackYProps={{
					renderer: props => {
						const { elementRef, ...restProps } = props;
						return (
							<span
								{...restProps}
								ref={elementRef}
								onMouseOver={onHoverOver ? () => onHoverOver() : () => {}}
								onMouseOut={onHoverOut ? () => onHoverOut() : () => {}}
								className='ScrollbarsCustom-Track ScrollbarsCustom-TrackY'
							/>
						);
					},
				}}
				scrollTop={scrollTop}
				//onScrollStart={() => onScrollStart()}
				onScrollStop={({ scrollTop }) => onScrollStop && onScrollStop(scrollTop)}
				disableTracksWidthCompensation
				noScrollX
				height={height}
			>
				{children}
			</Scrollbar>
		);
	} else {
		return (
			<Scrollbar
				thumbYProps={{
					renderer: props => {
						const { elementRef, ...restProps } = props;
						return (
							<div
								{...restProps}
								ref={elementRef}
								className={`ScrollbarsCustom-Thumb ScrollbarsCustom-ThumbY${scrollBarClass}`}
							/>
						);
					},
				}}
				trackYProps={{
					renderer: props => {
						const { elementRef, ...restProps } = props;
						return (
							<span
								{...restProps}
								ref={elementRef}
								onMouseOver={onHoverOver ? () => onHoverOver() : () => {}}
								onMouseOut={onHoverOut ? () => onHoverOut() : () => {}}
								className='ScrollbarsCustom-Track ScrollbarsCustom-TrackY'
							/>
						);
					},
				}}
				scrollTop={scrollTop}
				onScroll={scrollState => scrollStop(scrollState, onScrollStop, hasReachedBottom)}
				disableTracksWidthCompensation
				noScrollX
				height={height}
				// style={{ height }}
			>
				{children}
			</Scrollbar>
		);
	}
};

/**
 * purple: Default is False and will result in a grey scroller.
 * True will result in a purple scroller.
 */
BloxScrollViewNew.propTypes = {
	purple: bool,
	scrollTop: number,
	onScrollStop: func,
};

BloxScrollViewNew.defaultProps = {
	purple: false,
	scrollTop: undefined,
	onScrollStop: () => {},
};

export default BloxScrollViewNew;
